import { Col } from 'antd';
import breakpoints from 'constants/breakpoints';
import styled from 'styled-components';

import { LABEL_TYPE } from '../types';

export const DataOuterContainerStyled = styled.div<{ labelType?: LABEL_TYPE }>`
  width: 100%;
  display: flex;
  flex-flow: ${({ labelType }) => (labelType === LABEL_TYPE.above || labelType === LABEL_TYPE.under ? 'column' : 'row')}
    nowrap;
`;

export const InputContainerStyled = styled.div`
  display: flex;
  flex-flow: row nowrap;
  max-width: 100%;
  & > span {
    width: 100%;
  }
`;

export const LabelStyled = styled(Col)<{
  $labelType?: LABEL_TYPE;
  $marginHorizontal?: string;
  $marginVertical?: string;
  $responsive?: boolean;
}>`
  padding: 0;
  display: flex;
  align-items: center;
  margin-${({ $labelType }) => {
    switch ($labelType) {
      case LABEL_TYPE.above:
        return 'bottom';
      case LABEL_TYPE.left:
        return 'right';
      case LABEL_TYPE.under:
        return 'top';
      case LABEL_TYPE.right:
        return 'left';
      default:
        return 'right';
    }
  }}: ${({ $labelType, $marginHorizontal, $marginVertical }) => {
  switch ($labelType) {
    case LABEL_TYPE.above:
    case LABEL_TYPE.under:
      return $marginVertical || '5';
    case LABEL_TYPE.left:
    case LABEL_TYPE.right:
      return $marginHorizontal || '10';
    default:
      return $marginHorizontal || '10';
  }
}}px;
  order: ${({ $labelType }) => {
    switch ($labelType) {
      case LABEL_TYPE.above:
      case LABEL_TYPE.left:
        return 0;
      case LABEL_TYPE.under:
      case LABEL_TYPE.right:
        return 1;
      default:
        return 0;
    }
  }};
  @media screen and (max-width: ${breakpoints.sm}) {
    ${({ $responsive }) => ($responsive ? ' width: 100%;' : '')}
  }
`;

export const InputInGroupContainerStyled = styled.div`
  margin: 5px 0;
`;

export const ExtraContainerStyled = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-left: 5px;
`;

export const ErrorContainerStyled = styled(Col)`
  color: red;
  margin-top: 5px;
`;
